import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/main.css';
import './styles/warehouse-refresh.css';
import './styles/animations.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import AuthProvider from './AuthContext';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <AuthProvider> {/* Оборачиваем App в AuthProvider */}
      <App />
    </AuthProvider>
  </BrowserRouter>
);
